import { jsx as c } from "react/jsx-runtime";
import { Checkbox as h } from "@chakra-ui/react";
import n from "react";
import { CheckboxIcon as k } from "./checkbox-icon.js";
import { ThemeSpaceVariable as C } from "../../theme/theme-types.js";
const _ = n.forwardRef(
  ({
    children: t,
    size: r = "md",
    variant: e = "normal",
    display: f = "flex",
    alignItems: a = "center",
    justifyContent: l = "flex-start",
    gap: x = C.Small,
    isChecked: m,
    isIndeterminate: o,
    ...p
  }, b) => /* @__PURE__ */ c(
    h,
    {
      size: r,
      variant: e,
      colorScheme: "none",
      display: f,
      alignItems: a,
      isChecked: m,
      gap: x,
      justifyContent: l,
      isIndeterminate: o,
      "data-indeterminate": o,
      icon: /* @__PURE__ */ c(
        k,
        {
          variant: e,
          size: r,
          isChecked: m,
          isIndeterminate: o
        }
      ),
      ref: b,
      ...p,
      children: t
    }
  )
);
export {
  _ as Checkbox
};
